import React, { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faLightbulb,
    faInbox,
    faTrashAlt,
    faUser,
    faPhone,
    faIdCard,
} from '@fortawesome/free-solid-svg-icons'
import RequestQueue from '../../api/requestQueue'
import Loading from '../../component/loading'
import { toast } from 'react-toastify'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import { AppContextMenu } from '../../App'

const EmployeeIdeas = () => {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('employeeIdeas')
    }, [])

    const [loading, setLoading] = useState(false)
    const [ideas, setIdeas] = useState([])

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/employee-idea`,
            },
            resolve: (res) => {
                setIdeas(res.data)
                setLoading(false)
            },
            reject: () => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handleDelete = async (id) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'delete',
                url: `/employee-idea/${id}`,
            },
            resolve: () => {
                setLoading(false)
                fetchData()
            },
            reject: () => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="bg-white rounded-xl shadow-lg border border-gray-200 mx-4 my-6">
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-amber-500 to-orange-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faInbox}
                                    className="ml-2"
                                />
                                ایده‌های ثبت‌شده
                            </h2>
                        </div>
                        <div className="p-6">
                            {ideas.length === 0 ? (
                                <div className="text-center py-8 text-gray-500">
                                    <FontAwesomeIcon
                                        icon={faLightbulb}
                                        className="text-4xl mb-3"
                                    />
                                    <p>هنوز ایده‌ای ثبت نشده است</p>
                                </div>
                            ) : (
                                <div className="space-y-4">
                                    {ideas.map((idea) => (
                                        <div
                                            key={idea.id}
                                            className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors"
                                        >
                                            <div className="flex justify-between items-start">
                                                <div className="flex items-start">
                                                    <div className="bg-amber-100 p-2 rounded-full ml-3">
                                                        <FontAwesomeIcon
                                                            icon={faUser}
                                                            className="text-amber-700"
                                                        />
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium text-gray-900">
                                                            {idea.user
                                                                ?.full_name ||
                                                                '—'}
                                                        </p>
                                                        {idea.user
                                                            ?.personnel_code && (
                                                            <p className="text-xs text-gray-500 flex items-center mt-1">
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faIdCard
                                                                    }
                                                                    className="ml-1"
                                                                />
                                                                کد پرسنلی:{' '}
                                                                {
                                                                    idea.user
                                                                        .personnel_code
                                                                }
                                                            </p>
                                                        )}
                                                        {idea.user
                                                            ?.phone_number && (
                                                            <p className="text-xs text-gray-500 flex items-center mt-1">
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faPhone
                                                                    }
                                                                    className="ml-1"
                                                                />
                                                                {
                                                                    idea.user
                                                                        .phone_number
                                                                }
                                                            </p>
                                                        )}
                                                        <p className="text-xs text-gray-400 mt-1">
                                                            {FormJsonToShamsiDay(
                                                                idea.created_at
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() =>
                                                        handleDelete(idea.id)
                                                    }
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faTrashAlt}
                                                    />
                                                </button>
                                            </div>
                                            <div className="mt-3 text-gray-700 whitespace-pre-wrap">
                                                {idea.content}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default EmployeeIdeas
